import { useApolloClient } from '@apollo/client';
import { useEffect } from 'react';

import { useKeychain } from '@treams/auth';
import { useHistory } from '@treams/treams-routes';

export default function Logout() {
	const client = useApolloClient();
	const keychain = useKeychain();
	const history = useHistory();

	useEffect(() => {
		(async () => {
			const multi = keychain.all().length > 1;

			await client.clearStore();
			keychain.delete(keychain.all()[0]);
			client.resetStore();

			if (!multi) {
				window.location.href = '/authentication';
			} else {
				history.push('/');
			}
		})();
	}, []);

	return null;
}
